<template>

  <div>

    <el-form :inline="true" :model="query" @keyup.enter.native="load">

      <el-form-item label="应付单号"><el-input v-model="query.code" size="small" clearable /></el-form-item>

      <el-form-item label="供应商"><el-input v-model="query.partnerName" size="small" clearable /></el-form-item>

      <el-form-item>

        <el-button v-if="isAuth('finance:payable:list')" type="primary" size="small" @click="load">查询</el-button>

      </el-form-item>

      <el-form-item>

        <el-button v-if="isAuth('finance:payable:save')" type="primary" size="small" @click="addOrUpdateHandle()">新增</el-button>

      </el-form-item>

    </el-form>

    <el-table :data="shown" border v-loading="loading" :header-cell-style="headStyle">

      <el-table-column type="index" label="序号" width="60" align="center" />

      <el-table-column prop="code" label="应付单号" width="150">

        <template slot-scope="scope">

          <a v-if="isAuth('finance:payable:info')" class="code-link" @click="addOrUpdateHandle(scope.row.id, true)">{{ scope.row.code }}</a>

          <span v-else>{{ scope.row.code }}</span>

        </template>

      </el-table-column>

      <el-table-column prop="bizDate" label="业务日期" width="120" align="center" />

      <el-table-column prop="partnerName" label="供应商" min-width="160" />

      <el-table-column prop="totalAmount" label="价税合计" width="120" align="right">

        <template slot-scope="scope">{{ money(scope.row.totalAmount) }}</template>

      </el-table-column>

      <el-table-column prop="settledAmount" label="已付款" width="110" align="right">

        <template slot-scope="scope">{{ money(scope.row.settledAmount) }}</template>

      </el-table-column>

      <el-table-column prop="approveStatus" label="状态" width="90" align="center">

        <template slot-scope="scope">

          <el-tag v-if="scope.row.approveStatus === '2'" type="success" size="small">已审核</el-tag>

          <el-tag v-else type="info" size="small">未审核</el-tag>

        </template>

      </el-table-column>

    </el-table>

    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="load" />

  </div>

</template>



<script>

import AddOrUpdate from './payable-add-or-update'

import request from '../../api/request'

import auth from './financeAuth'



export default {

  name: 'Payable',

  mixins: [auth],

  components: { AddOrUpdate },

  data() {

    return {

      query: { code: '', partnerName: '' },

      list: [],

      addOrUpdateVisible: false

    }

  },

  computed: {

    shown() {

      return this.list.filter(row => {

        if (this.query.code && String(row.code || '').indexOf(this.query.code) < 0) return false

        if (this.query.partnerName && String(row.partnerName || '').indexOf(this.query.partnerName) < 0) return false

        return true

      })

    }

  },

  created() { this.load() },

  methods: {

    load() {

      this.loading = true

      request.get('/finance/arap/list', { params: { kind: 'payable' } }).then(res => { this.list = res.data || [] }).finally(() => { this.loading = false })

    },

    addOrUpdateHandle(id, readonly) {

      this.addOrUpdateVisible = true

      this.$nextTick(() => {

        this.$refs.addOrUpdate && this.$refs.addOrUpdate.init(id, readonly)

      })

    },
    open(id, readonly) { this.addOrUpdateHandle(id, !!readonly) }

  }

}

</script>



<style scoped>

.code-link { color: #348adb; cursor: pointer; }

</style>


